import { useMutation } from "react-query";

import axios, { AxiosError } from "axios";

import { GEO_CALCULATION_SERVICE_ADDRESS } from "../modals/constants";

export interface ModelSourceBoundingBox {
  minLat: number;
  maxLat: number;
  minLng: number;
  maxLng: number;
}

interface BoundsResponse {
  minx: number;
  miny: number;
  maxx: number;
  maxy: number;
}

export interface ModelSourceBoundingBoxParams {
  modelSource: string;
  zones?: string[];
}

/**
 * Fetches the spatial bounding box for a given geo model source.
 * Endpoint: GET /geo-calculation/model-source-bounds?modelSource=<source>&zones[]=<zone1>
 */
export function useGetModelSourceBoundingBox() {
  return useMutation<ModelSourceBoundingBox, AxiosError, ModelSourceBoundingBoxParams>(
    async (params: ModelSourceBoundingBoxParams) => {
      const queryParams = new URLSearchParams();
      queryParams.append("modelSource", params.modelSource);

      if (params.zones && params.zones.length > 0) {
        params.zones.forEach((zone) => queryParams.append("zones[]", zone));
      }

      const response = await axios.get(
        `${GEO_CALCULATION_SERVICE_ADDRESS}/geo-calculation/model-source-bounds?${queryParams.toString()}`
      );

      if (response.status !== 200) {
        throw new Error("Failed to fetch model source bounding box");
      }

      const data = response.data as BoundsResponse;

      // Map backend response to frontend interface
      return {
        minLat: data.miny,
        maxLat: data.maxy,
        minLng: data.minx,
        maxLng: data.maxx
      };
    }
  );
}
